import { render, staticRenderFns } from "./fresh.vue?vue&type=template&id=6be0c42a&scoped=true"
import script from "./fresh.vue?vue&type=script&lang=js"
export * from "./fresh.vue?vue&type=script&lang=js"
import style0 from "./fresh.vue?vue&type=style&index=0&id=6be0c42a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be0c42a",
  null
  
)

export default component.exports